import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (!authService.verificarAutenticacion()) {
    // Redirige al login si el usuario no está autenticado
    router.navigate(['/']);
    return false;
  }

  // Si deseas comprobar un rol específico, puedes pasar el rol requerido en la ruta
  const requiredRole = route.data['role'] as string;
  if (requiredRole && !authService.hasRole(requiredRole)) {
    // Redirige a una página de "No autorizado" si no cumple el rol
    router.navigate(['/']);
    return false;
  }

  // Permite el acceso
  return true;
};
